module.exports = __webpack_public_path__ + "media/images/eye-880d369c96f03ab69dd8dc89cf868607.svg";